import { apiClient } from '@/api/client'
import type { ControllerDetail, ControllerFormFields, ControllerListItem } from './types'

export async function fetchControllers(): Promise<ControllerListItem[]> {
  const { data } = await apiClient.get<ControllerListItem[]>('/portal/controllers/api/v2/controllers')
  return data
}

export async function fetchController(controllerId: string): Promise<ControllerDetail> {
  const { data } = await apiClient.get<ControllerDetail>(`/portal/controllers/${controllerId}`)
  return data
}

export async function createController(fields: ControllerFormFields): Promise<ControllerDetail> {
  const { data } = await apiClient.post<ControllerDetail>('/portal/controllers/controller/create', fields)
  return data
}

export async function updateController(
  controllerId: string,
  fields: Partial<ControllerFormFields>,
): Promise<ControllerDetail> {
  const { data } = await apiClient.post<ControllerDetail>(
    `/portal/controllers/controller/update/${controllerId}`,
    fields,
  )
  return data
}
